<template>
  <div class="stack-item destination">
    <div class="destination-distance">
      <span>{{
        isRide ? $t("SHARE_ORDER.PATH_INFO_RIDE") : $t("SHARE_ORDER.PATH_INFO")
      }}</span>
      <span>
        <span v-if="distance"
          >{{ isRide ? "" : " - " + $t("SHARE_ORDER.HEADER.DISTANCE") }}
          {{ distance }} km</span
        >
        <span v-if="stopPoint && stopPoint > 1 && !isRide"
          >&nbsp;- {{ stopPoint }} {{ $t("SHARE_ORDER.stopPoints") }}</span
        >
      </span>
    </div>
    <div class="destination-wrapper">
      <div class="item" v-for="(item, index) in data" :key="index">
        <div class="item-tail"></div>
        <div class="item-icon">
          <span v-if="index == 0" class="icon start">
            <svg style="width:16px;height:16px" viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
            </svg>
          </span>
          <div
            class="icon-completed-wapper"
            v-else-if="item.status === COMPLETED"
          >
            <span class="icon completed">
              <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                <path
                  fill="#4caf50"
                  d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z"
                />
              </svg>
            </span>
          </div>
          <span v-else-if="item.status === FAILED" class="icon failed">
            <svg style="width:16px;height:16px" viewBox="0 0 24 24">
              <path
                fill="#ef4d35"
                d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
              />
            </svg>
          </span>
          <span v-else class="icon processing">
            <svg style="width:16px;height:16px" viewBox="0 0 24 24">
              <path
                fill="#f37336"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
            </svg>
          </span>
        </div>
        <div class="item-content">
          <div class="address">
            {{ item.address }}
          </div>
          <div class="other-info">
            <span
              class="point point__pick-up"
              v-if="item.action_type === ORDER_PATH_ACTION_TYPE.PICK_UP"
              :title="$t('SHARE_ORDER.path.pick_up')"
            >
              <span class="icon is-small">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="5"
                    cy="5"
                    r="5"
                    fill="url(#paint0_linear_1580_17)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1580_17"
                      x1="-1.5"
                      y1="-3"
                      x2="5"
                      y2="10"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.000105574" stop-color="#96BDFF" />
                      <stop offset="1" stop-color="#234CFF" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <span>{{ $t("SHARE_ORDER.path.pick_up") }}</span>
            </span>
            <span
              class="point point__drop-off"
              v-if="item.action_type === ORDER_PATH_ACTION_TYPE.DROP_OFF"
              :title="$t('SHARE_ORDER.path.drop_off')"
            >
              <span class="icon is-small">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.58944 0L6.41056 0C7.65869 0 8.11129 0.129956 8.56758 0.373986C9.02388 0.618016 9.38198 0.97612 9.62601 1.43242C9.87004 1.88871 10 2.34131 10 3.58944V6.41056C10 7.65869 9.87004 8.11129 9.62601 8.56758C9.38198 9.02388 9.02388 9.38198 8.56758 9.62601C8.11129 9.87004 7.65869 10 6.41056 10H3.58944C2.34131 10 1.88871 9.87004 1.43242 9.62601C0.97612 9.38198 0.618016 9.02388 0.373986 8.56758C0.129956 8.11129 0 7.65869 0 6.41056V3.58944C0 2.34131 0.129956 1.88871 0.373986 1.43242C0.618016 0.97612 0.97612 0.618016 1.43242 0.373986C1.88871 0.129956 2.34131 0 3.58944 0Z"
                    fill="url(#paint0_linear_1580_18)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1580_18"
                      x1="-3"
                      y1="-4.5"
                      x2="6.82537"
                      y2="11.6924"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.000105574" stop-color="#FFC496" />
                      <stop offset="1" stop-color="#FF5F23" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <span>{{ $t("SHARE_ORDER.path.drop_off") }}</span>
            </span>
          </div>
          <div class="other-info">
            <span v-if="item.name" :title="$t('SHARE_ORDER.path.name')">
              <span class="icon is-small">
                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                  <path
                    fill="#142246"
                    d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
                  />
                </svg>
              </span>
              <span>{{ item.name }}</span>
            </span>
            <span v-if="item.mobile" :title="$t('SHARE_ORDER.path.mobile')">
              <span class="icon is-small">
                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                  <path
                    fill="#000000"
                    d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"
                  />
                </svg>
              </span>
              <span>{{ item.mobile }}</span>
            </span>
            <span
              v-if="item.tracking_number && tracking"
              :title="$t('SHARE_ORDER.path.tracking_number')"
            >
              <span class="icon is-small">
                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                  <path
                    fill="#000000"
                    d="M7,14A2,2 0 0,1 5,12A2,2 0 0,1 7,10A2,2 0 0,1 9,12A2,2 0 0,1 7,14M12.65,10C11.83,7.67 9.61,6 7,6A6,6 0 0,0 1,12A6,6 0 0,0 7,18C9.61,18 11.83,16.33 12.65,14H17V18H21V14H23V10H12.65Z"
                  />
                </svg>
              </span>
              <span>{{ item.tracking_number }}</span>
            </span>
            <span
              v-if="item.cod && item.cod > 0"
              :title="$t('SHARE_ORDER.path.cod')"
            >
              <span class="icon is-small">
                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                  <path
                    fill="#000000"
                    d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"
                  />
                </svg>
              </span>
              <span>{{
                item.cod.toLocaleString(locale, {
                  style: "currency",
                  currency: currency,
                })
              }}</span>
            </span>
            <span
              v-if="item.remarks"
              :title="$t('SHARE_ORDER.path.remarks') + `: ${item.remarks}`"
            >
              <span class="icon is-small">
                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                  <path
                    fill="#000000"
                    d="M21,6V8H3V6H21M3,18H12V16H3V18M3,13H21V11H3V13Z"
                  />
                </svg>
              </span>
              <span>{{ item.remarks }}</span>
            </span>
            <span
              class="red"
              v-if="item.fail_comment_label"
              :title="
                $t('SHARE_ORDER.path.fail_comment') +
                  `: ${$t(item.fail_comment_label)}`
              "
            >
              <span class="icon is-small">
                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                  <path
                    fill="#ef4d35"
                    d="M18,8H6V6H18V8M18,11H6V9H18V11M18,14H6V12H18V14M22,4A2,2 0 0,0 20,2H4A2,2 0 0,0 2,4V16A2,2 0 0,0 4,18H18L22,22V4Z"
                  />
                </svg>
              </span>
              <span>{{ $t(item.fail_comment_label) }}</span>
            </span>
            <span
              class="green"
              v-if="item.format_complete_time"
              :title="$t('SHARE_ORDER.path.complete_time')"
            >
              <span class="icon is-small">
                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                  <path
                    fill="#4caf50"
                    d="M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M19.03,7.39L20.45,5.97C20,5.46 19.55,5 19.04,4.56L17.62,6C16.07,4.74 14.12,4 12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22C17,22 21,17.97 21,13C21,10.88 20.26,8.93 19.03,7.39M11,14H13V8H11M15,1H9V3H15V1Z"
                  />
                </svg>
              </span>
              <span>{{ item.format_complete_time }}</span>
            </span>
            <span
              class="red"
              v-if="item.format_fail_time"
              :title="$t('SHARE_ORDER.path.fail_time')"
            >
              <span class="icon is-small">
                <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                  <path
                    fill="#ef4d35"
                    d="M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M19.03,7.39L20.45,5.97C20,5.46 19.55,5 19.04,4.56L17.62,6C16.07,4.74 14.12,4 12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22C17,22 21,17.97 21,13C21,10.88 20.26,8.93 19.03,7.39M11,14H13V8H11M15,1H9V3H15V1Z"
                  />
                </svg>
              </span>
              <span>{{ item.format_fail_time }}</span>
            </span>
            <span
              v-if="item.visa_photo_url"
              :title="$t('SHARE_ORDER.path.visa_photo_url')"
            >
              <span
                style="cursor: pointer"
                @click="openLink(item.visa_photo_url)"
                >{{ $t("SHARE_ORDER.path.detail_image") }}</span
              >
            </span>
            <span
              v-if="item.pod_info"
              :title="'pod'"
              class="pox_info"
              @click="setPOX(item.pod_info)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                style="width: 16px; height: 16px; margin-right: 12px; margin-left: 12px;"
              >
                <path
                  d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
                /></svg
              >pod
            </span>
            <span
              v-if="item.pof_info"
              :title="'pod'"
              class="pox_info"
              @click="setPOX(item.pof_info)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                style="width: 16px; height: 16px; margin-right: 12px; margin-left: 12px;"
              >
                <path
                  d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
                /></svg
              >pof
            </span>
            <span
              v-if="item.por_info"
              :title="'pod'"
              class="pox_info"
              @click="setPOX(item.por_info)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                style="width: 16px; height: 16px; margin-right: 12px; margin-left: 12px;"
              >
                <path
                  d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
                /></svg
              >por
            </span>
            <span
              v-if="item.pop_info"
              :title="'pod'"
              class="pox_info"
              @click="setPOX(item.pop_info)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                style="width: 16px; height: 16px; margin-right: 12px; margin-left: 12px;"
              >
                <path
                  d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
                /></svg
              >pop
            </span>
          </div>
        </div>
      </div>
    </div>
    <PoxInfo ref="poxRef" :img="pox_info" />
  </div>
</template>

<script>
// import Vue from "vue";
// const { ORDER_STATUS } = Vue.prototype.$constants
import { ORDER_STATUS, ORDER_PATH_ACTION_TYPE } from "@/mixins/constants";
import PoxInfo from "./PoxInfo.vue";

export default {
  name: "Destination",
  components: {
    PoxInfo,
  },
  props: {
    data: Array,
    distance: Number,
    currency: {
      default: "VND",
      type: String,
    },
    locale: {
      default: "vi",
      type: String,
    },
    tracking: Boolean,
    stopPoint: Number,
    isRide: {
      default: false,
      type: Boolean,
    },
  },
  data: () => {
    return {
      COMPLETED: ORDER_STATUS.COMPLETED,
      FAILED: ORDER_STATUS.FAILED,
      ORDER_PATH_ACTION_TYPE,
      pox_info: "",
    };
  },
  methods: {
    openLink(url) {
      window.open(url, "_blank");
    },
    setPOX(img) {
      this.pox_info = img;
      if (this.$refs.poxRef) {
        this.$refs.poxRef.visibleRatingModal = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.destination {
  padding-top: 0.6rem;
}

.destination-distance {
  padding-bottom: 5px;

  > span:first-child {
    font-size: 14px;
    font-weight: 500;
    padding-right: 5px;
  }

  span:nth-child(2) {
    display: inline-block;
    color: #616161;
    caret-color: #616161;
    font-size: 12px;
  }
}
.destination-wrapper {
  .item {
    display: flex;
    overflow: visible;
    min-height: 57px;
    position: relative;

    .item-tail {
      position: absolute;
      left: 12px;
      top: 0;
      height: 100%;
      width: 1px;
      padding: 30px 0 6px;
    }
    .item-tail:after {
      content: "";
      display: inline-block;
      border-radius: 1px;
      transition: background 0.3s;
      background-color: #ccd6dd;
      height: 100%;
      width: 1px;
      box-sizing: border-box;
    }

    .item-icon {
      float: left;
      line-height: 24px;
      font-weight: 600;

      .start {
        color: #142246;
        border-color: #142246;
      }
      .icon-completed-wapper {
        width: 24px;
        text-align: center;
      }
      .completed {
        color: #4caf50;
      }
      .failed {
        color: #ef4d35;
      }
      .processing {
        color: #f37336;
      }
    }

    .item-content {
      font-size: 14px;
      padding: 3px 0;

      .other-info {
        display: flex;
        flex-wrap: wrap;

        &:last-child {
          margin-bottom: 12px;
        }

        .is-small {
          svg {
            width: 14px;
            height: 21px;
          }
        }

        > span {
          display: flex;
          align-items: flex-start;
          outline: none;
          margin: 0 2px;
          border-radius: 20px;
          margin-top: 3px;
          cursor: default;
          // white-space: nowrap;
          overflow: hidden;
          max-width: 23vw;
          line-height: 21px;
          background-color: #eee;
          border: 1px solid #eee;

          span:first-child {
            margin-left: 5px;
            padding-top: 6px;
          }

          span:last-child {
            font-size: 12px;
            padding: 0 5px;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 19vw;
          }
        }

        .red {
          color: #ef4d35;
        }

        .green {
          color: #4caf50;
        }

        .point {
          font-weight: 500;
          &__pick-up {
            color: #234cff;
          }

          &__drop-off {
            color: #ff5f23;
          }
        }
        .pox_info {
          display: flex;
          cursor: pointer;
          padding-right: 12px;
          align-items: center;
        }
      }
    }
  }

  .item:last-child .item-tail::after {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .destination-wrapper {
    .item {
      .item-content {
        .other-info {
          > span {
            max-width: 80vw;
            span:last-child {
              max-width: 79vw;
            }
          }
        }
      }
    }
  }
}
</style>
